<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-75">
				<el-tabs v-model="tabName" v-if="loaded">
					<el-tab-pane label="ការភ្នាល់របស់អ្នកផ្តល់សេវាប្រចាំថ្ងៃ" name="5"></el-tab-pane>
					<el-tab-pane label="ការភ្នាល់របស់អ្នកផ្តល់សេវាប្រចាំខែ" name="6"></el-tab-pane>
					<el-tab-pane label="ការភ្នាល់របស់អ្នកផ្តល់សេវាដោយជ្រើសរើសកាលបរិច្ឆេទ" name="7"></el-tab-pane>
				</el-tabs>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25 text-right">
				<md-button class="md-raised md-primary" @click="refresh()">ធ្វើបច្ចប្បន្នភាពទិន្នន័យ</md-button>
			</div>
		</div>

		<div v-if="tabName == '5' && loaded">
			<md-table v-if="providerTodayList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ឈ្មោះអ្នកផ្តាល់សេវា</md-table-head>
					<md-table-head>ចំនួនភ្នាល់</md-table-head>
					<md-table-head>អតិថិជនឈ្នះ</md-table-head>
					<md-table-head>ក្រុមហ៊ុនចំណេញ</md-table-head>
				</md-table-row>

				<md-table-row v-for="(provider, index) in providerTodayList" v-if="provider.total_bet != 0">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/bet_user_detail/' + provider.id">
							<md-icon>visibility</md-icon>
							<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
						</router-link>
						<b>{{ provider.name }} </b></md-table-cell>
					<md-table-cell>
						<b>{{ config.moneylify(provider.total_bet * -1) }}</b>
					</md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="provider.total_bet + provider.total_win > 0">{{ config.moneylify(provider.total_win) }}</span>
						<span class="late" v-else-if="provider.total_bet + provider.total_win < 0">{{ config.moneylify(provider.total_win) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(provider.total_win) }}</span>
					</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="provider.total_bet + provider.total_win < 0">{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
						<span class="late" v-else-if="provider.total_bet + provider.total_win > 0">{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
					</b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(today_total_bet * -1) }}</b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(today_total_win) }}</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="today_total_bet + today_total_win < 0">{{ config.moneylify((today_total_bet + today_total_win) * -1) }}</span>
						<span class="late" v-else-if="today_total_bet + today_total_win > 0">{{ config.moneylify((today_total_bet + today_total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(today_total_bet + today_total_win) }}</span>
					</b></md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<div v-if="tabName == '6'">
			<md-table v-if="providerMonthlyList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ឈ្មោះអ្នកផ្តាល់សេវា</md-table-head>
					<md-table-head>ចំនួនភ្នាល់</md-table-head>
					<md-table-head>អតិថិជនឈ្នះ</md-table-head>
					<md-table-head>ក្រុមហ៊ុនចំណេញ</md-table-head>
				</md-table-row>

				<md-table-row v-for="(provider, index) in providerMonthlyList" v-if="provider.total_bet != 0">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/bet_user_detail/' + provider.id">
							<md-icon>visibility</md-icon>
							<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
						</router-link>
						<b>{{ provider.name }} </b>
					</md-table-cell>
					<md-table-cell>
						<b>{{ config.moneylify(provider.total_bet * -1) }}</b>
					</md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="provider.total_bet + provider.total_win > 0">{{ config.moneylify(provider.total_win) }}</span>
						<span class="late" v-else-if="provider.total_bet + provider.total_win < 0">{{ config.moneylify(provider.total_win) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(provider.total_win) }}</span>
					</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="provider.total_bet + provider.total_win < 0">{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
						<span class="late" v-else-if="provider.total_bet + provider.total_win > 0">{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
					</b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(monthly_total_bet * -1) }}</b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(monthly_total_win) }}</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="monthly_total_bet + monthly_total_win < 0">{{ config.moneylify((monthly_total_bet + monthly_total_win) * -1) }}</span>
						<span class="late" v-else-if="monthly_total_bet + monthly_total_win > 0">{{ config.moneylify((monthly_total_bet + monthly_total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(monthly_total_bet + monthly_total_win) }}</span>
					</b></md-table-cell>
				</md-table-row>
			</md-table>
		</div>

		<div v-if="tabName == '7'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-50 md-size-33">
					<md-field>
						<label>ថ្ងៃចាប់ផ្តើម</label>
						<md-input type="text" v-model="start_date" style="display:none" />
						<datetime type="datetime" v-model="start_date" auto></datetime>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-50 md-size-33">

					<md-field>
						<label>ថ្ងៃបញ្ចប់</label>
						<md-input type="text" v-model="end_date" style="display:none" />
						<datetime type="datetime" v-model="end_date" auto></datetime>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-button class="md-raised md-primary" style="width:100%" @click="getBetRange()">បង្ហាញ</md-button>
				</div>
			</div>
			<md-table v-if="providerRangeList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ឈ្មោះអ្នកផ្តាល់សេវា</md-table-head>
					<md-table-head>ចំនួនភ្នាល់</md-table-head>
					<md-table-head>អតិថិជនឈ្នះ</md-table-head>
					<md-table-head>ក្រុមហ៊ុនចំណេញ</md-table-head>
				</md-table-row>

				<md-table-row v-for="(provider, index) in providerRangeList" v-if="provider.total_bet != 0">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/bet_user_detail/' + provider.id">
							<md-icon>visibility</md-icon>
							<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
						</router-link>
						<b>{{ provider.name }} </b>
					</md-table-cell>
					<md-table-cell>
						<b>{{ config.moneylify(provider.total_bet * -1) }}</b>
					</md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="provider.total_bet + provider.total_win > 0">{{ config.moneylify(provider.total_win) }}</span>
						<span class="late" v-else-if="provider.total_bet + provider.total_win < 0">{{ config.moneylify(provider.total_win) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(provider.total_win) }}</span>
					</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="provider.total_bet + provider.total_win < 0">{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
						<span class="late" v-else-if="provider.total_bet + provider.total_win > 0">{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify((provider.total_bet + provider.total_win) * -1) }}</span>
					</b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(range_total_bet * -1) }}</b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(range_total_win) }}</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="range_total_bet + range_total_win < 0">{{ config.moneylify((range_total_bet + range_total_win) * -1) }}</span>
						<span class="late" v-else-if="range_total_bet + range_total_win > 0">{{ config.moneylify((range_total_bet + range_total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(range_total_bet + range_total_win) }}</span>
					</b></md-table-cell>
				</md-table-row>
			</md-table>
		</div>


	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		mounted() {
			let type = this.$store.state.authentication.account_type;
			if (type == 'sa') {
				return;
			} else {
				this.$router.push('/dashboard');
			}
		},
		components: { Datetime },
		created() {
			// this.getTransaction();
			this.getBetToday();
			// this.searchHandler();
		},
		watch: {
			'tabName': function() {
				if(this.tabName == '6') {
					this.getBetMonthly();
				}
			}
		},
		computed: {
			today_total_bet() {
				let total = 0;
				for(let i = 0; i< this.providerTodayList.length; i++) {
					total = total + this.providerTodayList[i].total_bet;
				}
				return total;
			},
			today_total_win() {
				let total = 0;
				for(let i = 0; i< this.providerTodayList.length; i++) {
					total = total + this.providerTodayList[i].total_win;
				}
				return total;
			},
			monthly_total_bet() {
				let total = 0;
				for(let i = 0; i< this.providerMonthlyList.length; i++) {
					total = total + this.providerMonthlyList[i].total_bet;
				}
				return total;
			},
			monthly_total_win() {
				let total = 0;
				for(let i = 0; i< this.providerMonthlyList.length; i++) {
					total = total + this.providerMonthlyList[i].total_win;
				}
				return total;
			},
			range_total_bet() {
				let total = 0;
				for(let i = 0; i< this.providerRangeList.length; i++) {
					total = total + this.providerRangeList[i].total_bet;
				}
				return total;
			},
			range_total_win() {
				let total = 0;
				for(let i = 0; i< this.providerRangeList.length; i++) {
					total = total + this.providerRangeList[i].total_win;
				}
				return total;
			}
		},
		data() {
			return {
				tabName: "5",
				loaded: true,
				loadMore: false,
				start_date: "",
				end_date: "",
				providerTodayList: [],
				providerMonthlyList: [],
				providerRangeList: []
			}
		},
		methods: {
			getBetToday(more = false) {
				this.$http.post(this.config.api + "/admin/get/provider_bet_stat/day",{
					offset: more == true ? this.providerTodayList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 50) this.loadMoreToday = true;
					else this.loadMoreToday = false;
					this.providerTodayList = more ? this.providerTodayList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			getBetMonthly(more = false) {
				this.$http.post(this.config.api + "/admin/get/provider_bet_stat/month",{
					offset: more == true ? this.providerMonthlyList.length : 0
				}).then(data => {
					this.secondLoaded = true;
					if (data.body.data.length == 50) this.loadMoreMonthly = true;
					else this.loadMoreMonthly = false;
					this.providerMonthlyList = more ? this.providerMonthlyList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			getBetRange(more = false) {
				let start_date = (new Date(this.start_date)).getTime();
				let end_date = (new Date(this.end_date)).getTime();

				this.$http.post(this.config.api + "/admin/get/provider_bet_stat/range",{
					start_date: start_date,
					end_date: end_date,
					offset: more == true ? this.providerRangeList.length : 0
				}).then(data => {
					this.thirdLoaded = true;
					if (data.body.data.length == 50) this.loadMoreRange = true;
					else this.loadMoreRange = false;
					this.providerRangeList = more ? this.providerRangeList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			refresh() {
				if(this.tabName == '5') {
					this.getBetToday();
				} else if (this.tabName == '6') {
					this.getBetMonthly();
				} else if(this.tabName == '7') {
					this.getBetRange();
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Reports/View.vue